import { connect } from 'react-redux'

import { SubmissionsHome } from '../components'
import { createPreClearedSubmission, downloadQuoteSubmission, downloadQuoteSpecimenSubmission } from './../actions'
// import * as actions from '../actions'
import * as selectors from '../selectors'

/**
 * Dispatches fecth clearance
 *
 * @param {Function} dispatch
 * @param {Object} data
 */
export const getQuotePreClearedSubmission = (dispatch, data) => {
  dispatch(createPreClearedSubmission(data));
};

/**
 * Dispatches download pdf as blob
 *
 * @param {Function} dispatch
 * @param {Object} user
 * @param {String} submissionID
 */
export const getDownloadQuoteSubmission = (dispatch, user, submissionID) => {
  dispatch(downloadQuoteSubmission(user, submissionID));
};

export const getDownloadQuoteSpecimenSubmission = (dispatch, user, submissionID, sessionFlag, isDeductibleSpecimen = false) => {
  dispatch(downloadQuoteSpecimenSubmission(user, submissionID, sessionFlag, isDeductibleSpecimen));
};

const mapStateToProps = state => ({
  user: selectors.getUser(state),
  brokerageName: selectors.getUserBrokerName(state),
})

export const mapDispatchToProps = dispatch => ({
  getQuotePreClearedSubmission: data => getQuotePreClearedSubmission(dispatch, data),
  getDownloadQuoteSubmission: (user, submissionID) => getDownloadQuoteSubmission(dispatch, user, submissionID),
  getDownloadQuoteSpecimenSubmission: (user, submissionID, sessionFlag = true, isDeductibleSpecimen) => getDownloadQuoteSpecimenSubmission(dispatch, user, submissionID, sessionFlag, isDeductibleSpecimen),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionsHome)
